/**
 * 插件管理器 React Context：在宿主树中向下传递 `PluginManager` 单例，
 * 供 iframe、工具栏、侧栏等子组件通过 `usePluginManager` 访问同一套插件状态与 Bridge。
 */
import { createContext, useContext } from "react";

import type { PluginManager } from "../runtime/plugin-manager";

/** 当前应用的 `PluginManager`；Provider 未挂载时为 `null`。 */
export const PluginManagerContext = createContext<PluginManager | null>(null);

/**
 * 读取上下文中的 `PluginManager`。
 * 需在 `PluginProvider` 包裹下使用；未挂载 Provider 时返回 `null`。
 */
export function usePluginManager(): PluginManager | null {
  return useContext(PluginManagerContext);
}
